import React, {  Component } from 'react';
import { getObject} from "../../api"
import AvatarDisplay from "../../common/avatarDisplay"
import '../../index.scss';

class JudgeProfile extends Component {
    constructor(props) {
        super(props);
        this.qType = this.props.qType ? this.props.qType : 'number'
        this.state = {
            loading: true
        }
    }

    loadUser = () => {
        this.setState({ loading: true});
        if (this.props.uid) {
            getObject('user', this.props.uid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({ userProfile: d2, loading: false});                    
                }
            });
        } else this.setState({ loading: false});
    };

    componentDidMount() {
        this.loadUser();        
    }

    render(){
        if (this.state.loading) { return null; }
        const { userProfile } = this.state;
        const {competitor} = this.props;

        return (
            <>
            <div className="row blog-media">
                <div className="col-xl-2">
                    <AvatarDisplay userId={userProfile._id} 
                        prefix={userProfile.displayname || (competitor && competitor.displayname)}
                        suffix="Judge"
                    /> 
                </div>
                <div className="col-xl-10">
                    <div className="media-body">
                    <h4>Biography</h4>
                    {userProfile.bio ? userProfile.bio :
                    <p>No bio was entered by this judge.&nbsp;</p>
                    }                    
                    </div>
                </div>
            </div>   
            <hr/>
            </>    
        )
    }
}

export default JudgeProfile;
